import React from 'react';
import Collapsible from '../../../components/Collapsible';
import ContentLayout from '../../../components/ContentLayout';
import props from '../../../lib/contentLayoutProps/life-at-kingston/layoutProps';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="en" pageKey="clubs-and-teams">
    <h1>Clubs and Teams</h1>
    <p>
      For a small school, Kingston has an impressive range of clubs and teams available for students to enjoy. These
      clubs have become essential elements of and sources of pride for our school community. From performing, to
      competing to beautifying our school and helping other schools, there are clubs for everyone's taste!
    </p>

    <Collapsible trigger="Kingston Environmental Group">
      <p>The KEG takes responsibility for promoting a greener campus and reducing our eco-footprint</p>
    </Collapsible>
    <Collapsible trigger="Student Representative Council">
      <p>
        Our democratically-elected student representative council organizes community events and helps students
        communicate their ideas for the direction of the school.
      </p>
    </Collapsible>
    <Collapsible trigger="Global Citizens">
      <p>
        The Global Citizens Initiative involves student-led fundraising for an underprivileged school in Jong Ra,
        Cambodia
      </p>
    </Collapsible>
    <Collapsible trigger="Kingston Choir & Orchestra">
      <p>
        Outside of regular class music time, students in Upper Primary also have the opportunity to join the Kingston
        Choir and Kingston Orchestra. The choir is currently made up of 52 enthusiastic students who enjoy singing in
        harmony and perform for the Kingston community 4 times throughout the school year. The Orchestra is a small
        group of dedicated string players who come together under the leadership our our Music Teacher to perform
        regularly at events throughout the school year as an orchestra and as accompanists for various student
        performances.
      </p>
    </Collapsible>
    <Collapsible trigger="Newspaper">
      <p>4 editions of the Kingston Student Newspaper are published by our intrepid student reporters and editors.</p>
    </Collapsible>
    <Collapsible trigger="Battle of the Books">
      <p>
        Kingston's Battle of the Books Team has proven to be a major contender in Hong Kong, having fought our way to
        multiple Finals and winning a city-wide Championship in 2012.
      </p>
    </Collapsible>
    <Collapsible trigger="Floor Hockey">
      <p>
        Floor hockey has long been the most popular sport at Kingston. We have more than 70 students from upper and
        lower primary playing weekly, with some competing yearly for the Kowloon Tong Cup Championship.
      </p>
    </Collapsible>
    <Collapsible trigger="Basketball">
      <p>Our basketball team is led by our Physical Education Teacher.</p>
    </Collapsible>
    <Collapsible trigger="Football">
      <p>
        Football is provided by the Brazilian Football Academy and stretches from Lower Primary through to Upper
        Primary. The Kingston team competes in yearly weekend tournaments.
      </p>
    </Collapsible>
  </ContentLayout>
);
